import React, { Component } from "react";
import { CloseOutlined, PlusCircleOutlined, ArrowsAltOutlined, ShrinkOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Input, Select, Tooltip } from "antd";
import CtleModel from "./CtleModel";
import TxModel from "./TxModel";
import RxModel from "./RxModel";
import RxCpadModel from "./RxCpadModel";
import SubcktNodeSelect from "./components/SubcktNodeSelect";
import {
  drawHelper,
  getDrawer,
  ctleKeyPrefixs,
  getNodeDataList,
  getNodeSelectOption,
  getSubcktByPairInfo,
  packageHspiceConfig,
  getIsShow,
  getTooltipPrefix,
  getModelKey,
  getClickBoxPosition,
  getContrAndDeviceSignalInfo,
  getExpandModelConnectWidth,
  getTxAndRxModelListBySignals,
  generateNewCompModel,
  getTitleList,
  getPCBBoxStyle,
} from "../../../services/Andes_v2/simulation";
import { END_TO_END_CHANNEL } from "../../../constants/treeConstants";
import { numberCheck } from "../../../services/helper/dataProcess";
import StimulusInputGroup from "./components/StimulusInputGroup";
import { getSelectICComps } from "../../../services/Andes_v2/AMIModelHelper";
import ExpandModelConnect from "./components/ExpandModelConnect";
import { PACKAGE } from "../../../constants/designType";
import "./index.css";
import ClickOutsideManager from "../Manager/ClickOutsideManager";

const pageState = {
  modelVisible: {
    txModel: false,
    rxModel: false,
    rxCpadModel: false,
    ctleModel: false
  },
  clickSignalInfo: {},
  clickSignal: {},
  controllerSignal: {},
  deviceSignal: {},
  // For staging termination input value
  editInputInfo: {},
  // settingVisible: false,
  // tx subckt node select list
  txSubckt: {},
  ctleSubckt: {}, // ctleKey -> subcktInfo
};

const classNamePrefix = "andes-v2-hspice-simulation";
class SimulationContent extends Component {
  constructor() {
    super();
    this.state = {
      canvasVisible: {
        rxCpad: true,
        ctle: true,
        rx: true,
        stimulus: true,
      },
      hspiceConfig: {},
      expandModelConnectVisible: false,
      txModelInfoList: [],
      rxModelInfoList: [],
      signalModelList: {},
      ...pageState,
    };
  }

  componentDidMount() {
    const { hspiceConfig, signals, channelType } = this.props;
    const { isShowCtle, isShowRxCpad, isShowRx, isShowStimulus } = getIsShow(hspiceConfig);
    const { drawer, canvas } = getDrawer(`${classNamePrefix}-canvas`, null, isShowStimulus ? { left: 210, top: 1.5 } : null);
    this.drawer = drawer;
    this.canvas = canvas;
    this.drawCanvas({ signals, isShowCtle, isShowRxCpad, isShowRx, isShowStimulus });
    this.unsubscribe = ClickOutsideManager.subscribe(this.handleClickOutside);

    const _hspiceConfig = packageHspiceConfig(hspiceConfig, channelType, signals);
    this.setState({
      hspiceConfig: _hspiceConfig,
      canvasVisible: {
        rxCpad: isShowRxCpad,
        ctle: isShowCtle,
        rx: isShowRx,
        stimulus: isShowStimulus
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {
      signals,
      hspiceConfig,
      channelLoading,
      simulationSolver,
      hspiceConfigStatus,
      channelType,
      endToEndChannelId,
      txCompInfo,
      rxCompInfo,
      components,
      isUpdateComponentModel,
      isPreLayout,
      preLayoutModel
    } = this.props;
    const { txModelInfoList, rxModelInfoList, expandModelConnectVisible } = this.state;
    const { controller, device } = hspiceConfig;
    let otherUpdateState = {};
    if (expandModelConnectVisible) {
      const newTxModelInfoList = generateNewCompModel(txCompInfo, "tx");
      const newRxModelInfoList = generateNewCompModel(rxCompInfo, "rx");
      if (txModelInfoList.length !== newTxModelInfoList.length
        || rxModelInfoList.length !== newRxModelInfoList.length
        || isUpdateComponentModel
        || controller !== (prevProps.hspiceConfig || {}).controller
        || device !== (prevProps.hspiceConfig || {}).device) {
        otherUpdateState = {
          txModelInfoList: newTxModelInfoList,
          rxModelInfoList: newRxModelInfoList,
          signalModelList: getTxAndRxModelListBySignals(components, signals, isPreLayout ? preLayoutModel : undefined, txCompInfo, rxCompInfo, newTxModelInfoList, newRxModelInfoList)
        }
        this.props.updateComponentModel();
      }
    }
    // change channel
    if (
      (channelLoading !== prevProps.channelLoading && !channelLoading)
      || simulationSolver !== prevProps.simulationSolver
      || signals.length !== prevProps.signals.length
      || endToEndChannelId !== prevProps.endToEndChannelId
      || Object.keys(otherUpdateState).length
    ) {
      const { isShowCtle, isShowRxCpad, isShowRx, isShowStimulus } = getIsShow(hspiceConfig);
      this.drawCanvas({
        signals,
        isShowCtle,
        isShowRxCpad,
        isShowRx,
        isShowStimulus,
        ...getExpandModelConnectWidth(otherUpdateState.txModelInfoList || txModelInfoList, otherUpdateState.rxModelInfoList || rxModelInfoList),
      });
      const _hspiceConfig = packageHspiceConfig(hspiceConfig, channelType, signals);

      this.setState({
        hspiceConfig: _hspiceConfig,
        canvasVisible: {
          rxCpad: isShowRxCpad,
          ctle: isShowCtle,
          rx: isShowRx,
          stimulus: isShowStimulus
        },
        ...otherUpdateState,
        ...pageState
      });
    }

    if (hspiceConfigStatus) {
      this.setState({ hspiceConfig: packageHspiceConfig(hspiceConfig, channelType, signals) });
      this.props._updateHspiceConfigStatus(false);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const { nodeVisible } = this.state;
    const PopoverRoot = document.getElementById(nodeVisible);

    if (!PopoverRoot) {
      return;
    }

    if (!PopoverRoot || !PopoverRoot.contains(target)) {
      this.setState({ nodeVisible: "" });
    }
  };

  drawCanvas = ({ signals, isShowCtle, isShowRxCpad, isShowRx, isShowStimulus, txExpandConnectWidth, rxExpandConnectWidth }) => {
    if (!signals.length) return;
    const { expandModelConnectVisible } = this.state;
    // height = 400 * signal number
    const height = 400 * signals.length;
    const expandModelConnectWidth = expandModelConnectVisible ? txExpandConnectWidth + rxExpandConnectWidth + 50 : 0;
    const otherWidth = (isShowStimulus ? 200 : 0) + expandModelConnectWidth;
    drawHelper({
      drawer: this.drawer,
      canvas: this.canvas,
      openModal: this.openModal,
      signals,
      height,
      isShowCtle,
      isShowRxCpad,
      isShowRx,
      width: isShowCtle ? 1250 + otherWidth : 1000 + otherWidth,
      isShowStimulus,
      padding: isShowStimulus ? { left: 210, top: 1.5 } : null,
      txExpandConnectWidth,
      rxExpandConnectWidth,
      expandModelConnectVisible
    });
  };

  // according to type and signalIndex open panel，init data
  openModal = (modalType, signalIndex) => {
    const { hspiceConfig: { signals: hspiceSignals, controllerChannel = {}, deviceChannel = {} } } = this.state;
    const { signals, controllerInfo = {}, deviceInfo = {}, channelType } = this.props;
    const signalName = signals[signalIndex].name;
    const hspiceSignal = hspiceSignals.find((item) => item.signalName === signalName);
    const signal = signals.find((item) => item.name === signalName);
    let controllerSignal = {}, deviceSignal = {};
    if (channelType === END_TO_END_CHANNEL) {
      const { contrSignalInfo, deviceSignalInfo } = getContrAndDeviceSignalInfo({
        signals,
        controllerChannelId: controllerChannel.channelId,
        deviceChannelId: deviceChannel.channelId,
        signalName,
        contrSignals: controllerInfo.content && controllerInfo.content.signals ? controllerInfo.content.signals : [],
        deviceSignals: deviceInfo.content && deviceInfo.content.signals ? deviceInfo.content.signals : [],
        type: modalType
      });

      controllerSignal = contrSignalInfo;
      deviceSignal = deviceSignalInfo;
    }

    this.setState({
      modelVisible: {
        ...this.state.modelVisible,
        [modalType]: true,
      },
      clickSignalInfo: hspiceSignal,
      clickSignal: signal,
      controllerSignal,
      deviceSignal
    });
  };

  closeModal = (modelType, model, applyToAll) => {
    const { clickSignalInfo, hspiceConfig, clickSignal, controllerSignal, deviceSignal } = this.state;
    const { signals, channelType, controllerInfo, deviceInfo } = this.props;
    let _hspiceConfig = hspiceConfig;
    const signalInfo = channelType === END_TO_END_CHANNEL ? (modelType === 'txModel' ? controllerSignal : deviceSignal) : clickSignal
    if (applyToAll) {
      const signalsList = channelType === END_TO_END_CHANNEL ? (modelType === 'txModel' ? controllerInfo.content.signals : deviceInfo.content.signals) : signals;
      _hspiceConfig = hspiceConfig.applyToAllSignals({ modelType, model, signals, signalsList, signalInfo, channelType });
    } else {
      _hspiceConfig = hspiceConfig.setModelBySignalName(
        modelType,
        clickSignalInfo.signalName,
        model
      );
    }
    this.setState(
      {
        modelVisible: {
          ...this.state.modelVisible,
          [modelType]: false,
        },
        hspiceConfig: _hspiceConfig,
        clickSignalInfo: {},
        clickSignal: {},
        controllerSignal: {},
        deviceSignal: {}
      }, () => {
        this.props._updateHSPICEConfig(_hspiceConfig);
      }
    );
  };

  changeCanvasEle = (type, value) => {
    const { hspiceConfig } = this.state;
    // change model type
    let _hspiceConfig = hspiceConfig;
    if (type !== 'stimulus') {
      _hspiceConfig.setModelType(`${type}Model`, value);
    }
    this.setState({
      canvasVisible: {
        ...this.state.canvasVisible,
        [type]: value
      },
      hspiceConfig: _hspiceConfig
    }, () => {
      const { signals } = this.props;
      const {
        canvasVisible: { ctle: isShowCtle, rxCpad: isShowRxCpad, rx: isShowRx, stimulus: isShowStimulus },
        txModelInfoList, rxModelInfoList
      } = this.state;
      this.drawCanvas({
        signals,
        isShowCtle,
        isShowRxCpad,
        isShowRx,
        isShowStimulus,
        ...getExpandModelConnectWidth(txModelInfoList, rxModelInfoList)
      });
      this.props._updateHSPICEConfig(_hspiceConfig);
    });
  };

  changeEditInputInfo = (item) => {
    this.setState({ editInputInfo: { ...item } });
  };

  editInputBlur = (signalName, { key, unit, pin }) => {
    const {
      hspiceConfig,
      editInputInfo: { value },
    } = this.state;
    let _hspiceConfig = null;
    if (!numberCheck(value)) {
      const isCap = key.includes("Cap");
      _hspiceConfig = hspiceConfig.setTerminationValue(
        signalName,
        pin,
        `${value} ${unit}`,
        isCap
      );
    }
    this.setState({
      hspiceConfig: _hspiceConfig || hspiceConfig,
      editInputInfo: {},
    }, () => {
      this.props._updateHSPICEConfig(_hspiceConfig || hspiceConfig);
    });
  };

  selectNode = ({ node, pin }, signalName, modelType) => {
    const { hspiceConfig } = this.state;
    let _hspiceConfig = hspiceConfig;
    _hspiceConfig = hspiceConfig.setSignalModelNode(signalName, pin, node, modelType);
    this.setState({ hspiceConfig: _hspiceConfig, nodeVisible: "" }, () => {
      this.props._updateHSPICEConfig(_hspiceConfig);
    });
  };

  clearNodeVisible = () => {
    this.setState({ nodeVisible: "" });
  };

  setTxNodeVisible = async (visible, allInfo, txModel = {}) => {
    const { files = [] } = txModel;
    const fileInfo = allInfo.node
      ? allInfo
      : files.length > 0
        ? files[0]
        : null;
    if (visible && fileInfo) {
      // get nodeList
      const subcktInfo = await getSubcktByPairInfo(fileInfo);
      this.setState({ txSubckt: subcktInfo });
    }
    this.setState({ nodeVisible: visible });
  };

  setCtleNodeVisible = async (visible, { allInfo, key }, ctleModel = {}) => {
    const { ctleSubckt } = this.state;
    const { files = [] } = ctleModel;
    const pairIndex = allInfo.pairIndex;
    const spiceType = files.length > 1 ? 'only' : 'share';
    const modelKey = getModelKey({ files, pairIndex, modelKey: allInfo.modelKey, spiceType })
    const fileInfo = allInfo.node ? allInfo : files.find((item) => item.modelKey === modelKey);
    if (visible && fileInfo) {
      const subcktInfo = await getSubcktByPairInfo(fileInfo);
      this.setState({ ctleSubckt: { ...ctleSubckt, [key]: subcktInfo } });
    }
    this.setState({ nodeVisible: visible });
  };

  getNodeList = (signalName, index, ctleDataList) => {
    const {
      txSubckt,
      ctleSubckt,
      hspiceConfig: { signals = [] },
    } = this.state;
    const signalConfig = signals.find((item) => item.signalName === signalName) || {};
    const { txModel = {}, ctleModel = {} } = signalConfig;
    const txNodeList = getNodeSelectOption("txModel", txModel.pairs, txSubckt);
    // ctle
    let ctleNodeLists = {};
    for (const keyPrefix of ctleKeyPrefixs) {
      const key = `${keyPrefix}${index}`;
      let pairs = ctleModel.pairs;
      if ((ctleModel.files || []).length > 1) {
        const ctleData = ctleDataList.find((item) => item.key === key);
        pairs = [ctleData.leftValue, ctleData.rightValue];
      }
      const ctleNodeList = getNodeSelectOption(
        "ctleModel",
        pairs,
        ctleSubckt[key]
      );
      ctleNodeLists[key] = ctleNodeList;
    }
    return { txNodeList, ctleNodeLists };
  };

  updateStimulus = (signalName, stimulus, applyAll) => {
    const { hspiceConfig } = this.state;
    const _hspiceConfig = hspiceConfig.setStimulus(signalName, stimulus, applyAll);
    this.setState({ hspiceConfig: _hspiceConfig }, () => {
      this.props._updateHSPICEConfig(_hspiceConfig);
    });
  }

  titleRender = () => {
    const { canvasVisible = {}, hspiceConfig, expandModelConnectVisible, txModelInfoList, rxModelInfoList } = this.state;
    const {
      components, channelType,
      simulationSolver, designType,
      controllerICComps, deviceICComps,
      contrPCBIndex, devicePCBIndex,
      controllerInfo, deviceInfo
    } = this.props;
    const { controller, device } = hspiceConfig;
    const { contrComps, deviceComps } = getSelectICComps({
      interfaceType: channelType,
      components,
      controllerICComps,
      deviceICComps,
      simulationSolver
    });
    return getTitleList({ isShowStimulus: canvasVisible.stimulus, expandModelConnectVisible, designType, ...getExpandModelConnectWidth(txModelInfoList, rxModelInfoList) }).map(item => {
      const otherClassName = item.type === 'ctle' && !canvasVisible.ctle ? `ctle-title-not-exist-ctle` : ''
      return <div key={`${item.type}-title`} className={`${classNamePrefix}-title ${item.type}-title ${otherClassName}`} style={item.style}>
        {
          ['stimulus', 'termination', 'tx'].includes(item.type) ? item.title
            : item.type === 'txComp' ? <>
              <div className="top-title">{item.title}</div>
              {this.componentSelectRender("controller", controller, contrComps, channelType, contrPCBIndex, controllerInfo)}
            </>
              : item.type === 'rxComp' ? <>
                <div className="top-title">{item.title}</div>
                {this.componentSelectRender("device", device, deviceComps, channelType, devicePCBIndex, deviceInfo)}
              </>
                : item.type === 'pcb-icon' ? <></>
                  : canvasVisible[item.type] ? <>
                    {item.title}
                    <CloseOutlined
                      title={`Delete ${item.title}`}
                      className={`${classNamePrefix}-icon`}
                      onClick={() => this.changeCanvasEle(item.type, false)}
                    />
                  </> : <PlusCircleOutlined
                    title={`Add ${item.title}`}
                    className={`${classNamePrefix}-icon ${classNamePrefix}-add-icon`}
                    onClick={() => this.changeCanvasEle(item.type, true)}
                  />
        }
      </div>
    })
  }

  positionEleRender = (signalName, index) => {
    const {
      canvasVisible,
      editInputInfo,
      hspiceConfig: { signals: hspiceSignals = [], controllerChannel = {}, deviceChannel = {}, controller, device },
      nodeVisible,
      expandModelConnectVisible,
      txModelInfoList,
      rxModelInfoList,
      signalModelList
    } = this.state;
    const { signals, channelType, controllerInfo = {}, deviceInfo = {}, txCompInfo, rxCompInfo, isPreLayout } = this.props;

    const expandModelConnectWidth = expandModelConnectVisible ? getExpandModelConnectWidth(txModelInfoList, rxModelInfoList, "number") : 0;
    const {
      rxCpad: isShowRxCpad,
      ctle: isShowCtle,
      rx: isShowRx,
      stimulus: isShowStimulus
    } = canvasVisible;
    const hspiceSignalConfig = hspiceSignals.find((item) => item.signalName === signalName) || {};
    const {
      txNodeDataList,
      txNetDataList,
      z0DataList,
      ctleDataList,
      rxModelDataList,
      rxCpadDataList,
      stimulusPatternDataList
    } = getNodeDataList({
      signalName,
      index,
      hspiceSignalConfig,
      signals,
      isShowStimulus,
      channelType,
      controllerChannel,
      deviceChannel,
      contrSignals: controllerInfo.content && controllerInfo.content.signals ? controllerInfo.content.signals : [],
      deviceSignals: deviceInfo.content && deviceInfo.content.signals ? deviceInfo.content.signals : [],
      expandModelConnectWidth,
      expandModelConnectVisible
    });
    const { txNodeList, ctleNodeLists } = this.getNodeList(
      signalName,
      index,
      ctleDataList
    );
    const { rxCpadPrefix, rxPrefix } = getTooltipPrefix(hspiceSignalConfig);

    return (
      <>
        {/* stimulus */}
        {isShowStimulus ? <div
          style={{ top: index * 400 + 10 + (expandModelConnectVisible ? 32 : 0) }}
          className={`${classNamePrefix}-stimulus`}
        >
          <StimulusInputGroup
            signalName={signalName}
            stimulus={hspiceSignalConfig.stimulus || {}}
            updateStimulus={this.updateStimulus}
          />
        </div> : null}
        {/* SignalName */}
        {!expandModelConnectVisible
          || (signalModelList[signalName] && signalModelList[signalName].layout && (signalModelList[signalName].layout.pairs || {}).length === 0)
          ? <div
            className={`${classNamePrefix}-canvas-signal-name andes-v2-hspice-no-wrap`}
            style={{
              top: index * 400 + 120 + (expandModelConnectVisible ? 32 : 0),
              left: 320 + (isShowStimulus ? 200 : 0) + txModelInfoList.length * 130,
              width: expandModelConnectVisible ? 250 : 200
            }}
            title={signalName}
          >
            {signalName}
          </div> : null}
        {/* Tx - node*/}
        {!isShowStimulus ? txNodeDataList.map((item) => (
          <div
            className={`${classNamePrefix}-canvas-div`}
            style={{ left: item.left, top: item.top }}
            onClick={() => this.changeEditInputInfo(item)}
            key={item.key}
          >
            <SubcktNodeSelect
              id={`simulation-subckt-node-popover-${item.key}`}
              nodeList={txNodeList}
              nodeValue={item.value}
              displayPin={item.pin}
              selectNode={(node) => this.selectNode({ node, pin: item.pin }, signalName, "txModel")}
              visible={nodeVisible === `simulation-subckt-node-popover-${item.key}`}
              clickNode={() =>
                this.setTxNodeVisible(
                  `simulation-subckt-node-popover-${item.key}`,
                  item.allInfo,
                  hspiceSignalConfig.txModel
                )
              }
              closeNodelSelect={() => this.clearNodeVisible()}
            />
          </div>
        )) : null}
        {/* stimulus - pattern */}
        {/* Tx - net */}
        {[...txNetDataList, ...stimulusPatternDataList].map((item) => (
          <div
            key={item.key}
            className={`${classNamePrefix}-canvas-div-net`}
            style={{ left: item.left, top: item.top }}
            title={item.value}
          >
            {item.value}
          </div>
        ))}
        {/* Rx - Model */}
        {isShowRx ? rxModelDataList.map((item) => (
          <Tooltip
            placement="top"
            title={`${rxPrefix}${item.modelName || item.node}`}
            key={item.key}
            onClick={() => this.openModal("rxModel", index)}
          >
            <div
              className={`${classNamePrefix}-canvas-div`}
              key={item.key}
              style={{ left: item.left, top: item.top }}
            >
              {item.modelName || item.node}
            </div>
          </Tooltip>
        )) : null}
        {/* RxCpad */}
        {isShowRxCpad ? rxCpadDataList.map((item) => (
          <Tooltip
            placement="top"
            title={`${rxCpadPrefix}${item.cpadValue || item.node}`}
            key={item.key}
            onClick={() => this.openModal("rxCpadModel", index)}
          >
            <div
              className={`${classNamePrefix}-canvas-div ${classNamePrefix}-canvas-div-rxCpad`}
              style={{ left: item.left, top: item.top }}
            >
              {item.cpadValue || item.node}
            </div>
          </Tooltip>
        )) : null}
        {/* Z0 */}
        {z0DataList.map((item) => {
          return (
            <div
              className={`spice-pin-value-box ${classNamePrefix}-input`}
              style={{ left: item.left, top: item.top }}
              key={item.key}
              onClick={() => this.changeEditInputInfo(item)}
            >
              {editInputInfo.key === item.key || !item.value ? (
                <Input
                  className={`${classNamePrefix}-z0-input`}
                  placeholder="Z0"
                  value={editInputInfo.value}
                  onChange={(e) =>
                    this.changeEditInputInfo({
                      ...editInputInfo,
                      value: e.target.value,
                    })
                  }
                  onBlur={() => this.editInputBlur(signalName, item)}
                  onPressEnter={() => this.editInputBlur(signalName, item)}
                  suffix={item.key.includes("Cap") ? "pF" : "Ω"}
                  autoFocus={editInputInfo.key === item.key}
                  disabled={item.key.includes("Cap") ? false : !item.pin}
                />
              ) : (
                <span className="spice-pin-value">
                  {item.key.includes("Cap")
                    ? (<>Cap: {item.value} {item.unit}</>)
                    : (<>R: {item.value} {item.unit.replace("Ohm", "Ω")}</>)}
                </span>
              )}
            </div>
          );
        })}
        {/* ctle */}
        {isShowCtle ? ctleDataList.map((item) => (
          <div
            className={`${classNamePrefix}-ctle-item ${classNamePrefix}-ctle-item-zIndex`}
            key={item.key}
            style={{ left: item.left, top: item.top }}
          >
            <SubcktNodeSelect
              id={`simulation-subckt-node-popover-${item.key}-left`}
              displayPin={item.leftValue.pin}
              nodeValue={item.leftValue.node}
              nodeList={ctleNodeLists[item.key] || []}
              selectNode={(node) =>
                this.selectNode(
                  {
                    node,
                    pin: item.leftValue.pin,
                    component: item.leftValue.component,
                  },
                  signalName,
                  "ctleModel"
                )
              }
              visible={nodeVisible === `simulation-subckt-node-popover-${item.key}-left`}
              clickNode={() =>
                this.setCtleNodeVisible(
                  `simulation-subckt-node-popover-${item.key}-left`,
                  { key: item.key, allInfo: item.leftValue },
                  hspiceSignalConfig.ctleModel
                )
              }
              closeNodelSelect={() => this.clearNodeVisible()}
            />
            <SubcktNodeSelect
              id={`simulation-subckt-node-popover-${item.key}-right`}
              displayPin={item.rightValue.pin}
              nodeValue={item.rightValue.node}
              nodeList={ctleNodeLists[item.key] || []}
              selectNode={(node) =>
                this.selectNode(
                  {
                    node,
                    pin: item.rightValue.pin,
                    component: item.rightValue.component,
                  },
                  signalName,
                  "ctleModel"
                )
              }
              visible={nodeVisible === `simulation-subckt-node-popover-${item.key}-right`}
              clickNode={() =>
                this.setCtleNodeVisible(
                  `simulation-subckt-node-popover-${item.key}-right`,
                  { key: item.key, allInfo: item.rightValue },
                  hspiceSignalConfig.ctleModel
                )
              }
              closeNodelSelect={() => this.clearNodeVisible()}
            />
          </div>
        )) : null}
        {/* Clickable area box */}
        {/* tx/rx */}
        {getClickBoxPosition(canvasVisible, index, expandModelConnectWidth, expandModelConnectVisible).map(position => {
          return <div
            key={position.key}
            className={`${classNamePrefix}-canvas-click-box ${position.className}`}
            style={{ left: position.left, top: position.top }}
            onClick={() => this.openModal(position.modalType, index)}
          >
          </div>
        })}

        {/* expand pcb box */}
        {expandModelConnectVisible ? <div
          className={`${classNamePrefix}-canvas-expand-model-connect-box`}
          style={{ left: 320 + (canvasVisible.stimulus ? 200 : 0), top: 42 + 400 * index }}
        >
          <ExpandModelConnect
            signalName={signalName}
            controller={controller}
            device={device}
            txCompInfo={txCompInfo}
            rxCompInfo={rxCompInfo}
            modelList={signalModelList[signalName]}
            scrollToAnchor={this.props.scrollToAnchor}
            changeNeedChangeComp={this.props.changeNeedChangeComp}
            isPreLayout={isPreLayout}
            clickPCBBox={this.clickPCBBox}
          />
        </div> : null}
      </>
    );
  };

  changeComponent = (currType, compAndPCB, compInfo, prePcbIndex) => {
    const { hspiceConfig } = this.state;
    const { components, channelType, controllerICComps, deviceICComps, controllerInfo, deviceInfo, signals } = this.props;
    const otherType = currType === "controller" ? "device" : "controller";
    const _components = channelType === END_TO_END_CHANNEL ? (currType === "controller" ? controllerICComps : deviceICComps) : components;
    const [compName, pcbStr] = compAndPCB.split("::");
    const resComp = _components.find((item) => item.name === compName) || {};
    // If currently want to replace the result comp is another comp, swap controller and device, then replace txModel, rxModel inside the pin
    let _hspiceConfig = null;
    if (resComp.name === hspiceConfig[otherType] && channelType !== END_TO_END_CHANNEL) {
      const currComp = components.find((item) => item.name === hspiceConfig[currType]) || {};
      let controllerComp = resComp,
        deviceComp = currComp;
      if (currType === "device") {
        controllerComp = currComp;
        deviceComp = resComp;
      }

      _hspiceConfig = hspiceConfig.handleCompnentSwap({
        controllerComp,
        deviceComp,
        channelType,
        signals
      });
    } else if (`PCB ${prePcbIndex + 1}` !== pcbStr && channelType === END_TO_END_CHANNEL) {
      const contrCompName = currType === "controller" ? compName : hspiceConfig[currType];
      const deviceCompName = currType === "device" ? compName : hspiceConfig[currType];
      const controllerComp = deviceICComps.find((item) => item.name === contrCompName) || {};
      const deviceComp = controllerICComps.find((item) => item.name === deviceCompName) || {};

      _hspiceConfig = hspiceConfig.handleCompnentSwap({
        controllerComp,
        deviceComp,
        channelType,
        deviceInfo,
        controllerInfo,
        signals
      });
    } else {
      // Replace the corresponding txModel/rxModel and ctleModel
      _hspiceConfig = hspiceConfig.handleComponentChange({
        currType,
        resComp,
        channelType,
        compInfo,
        signals
      });
    }

    this.setState({ hspiceConfig: _hspiceConfig || hspiceConfig }, () => {
      this.props._updateHSPICEConfig(_hspiceConfig || hspiceConfig);
      if (`PCB ${prePcbIndex + 1}` !== pcbStr && channelType === END_TO_END_CHANNEL) {
        this.props.setData();
      }
    });
  };

  componentSelectRender = (type, value, components, channelType, pcbIndex, compInfo) => {
    const _value = channelType === END_TO_END_CHANNEL && value ? `${value}::PCB ${pcbIndex + 1}` : value;
    let displayComp = value;
    const options = components.map(item => {
      let compStr = item.name;
      if (item.isMergeComp || item.isCopyComp) {
        compStr = `${item.pins.map(it => it.pin).join(', ')} (${item.layer})`
      }

      if (item.name === value) {
        displayComp = compStr;
      }
      return {
        value: item.pcb ? `${item.name}::${item.pcb}` : item.name,
        label: item.pcb ? `${item.pcb} - ${compStr}` : compStr
      }
    })
    return <Tooltip
      classNames={{ root: 'aurora-tooltip andes-ami-model-tooltip' }}
      title={channelType === END_TO_END_CHANNEL ? `Design: PCB ${pcbIndex + 1}\nComponent: ${displayComp}` : displayComp}
    >
      <Select
        className={`${classNamePrefix}-component-select`}
        onChange={(value) => this.changeComponent(type, value, compInfo, pcbIndex)}
        value={_value}
        popupMatchSelectWidth={false}
        options={options}
      />
    </Tooltip>
  }

  clickPCBBox = (e, value) => {
    e.stopPropagation();
    const { txCompInfo, rxCompInfo, components, signals, isPreLayout, preLayoutModel } = this.props;

    let txModelInfoList = [], rxModelInfoList = [], signalModelList = {};
    if (value) {
      txModelInfoList = generateNewCompModel(txCompInfo, 'tx');
      rxModelInfoList = generateNewCompModel(rxCompInfo, 'rx');
      signalModelList = getTxAndRxModelListBySignals(components, signals, isPreLayout ? preLayoutModel : undefined, txCompInfo, rxCompInfo, txModelInfoList, rxModelInfoList);
    }

    this.setState({
      expandModelConnectVisible: value,
      txModelInfoList,
      rxModelInfoList,
      signalModelList
    }, () => {
      const { signals } = this.props;
      const {
        canvasVisible: { ctle: isShowCtle, rxCpad: isShowRxCpad, rx: isShowRx, stimulus: isShowStimulus },
        txModelInfoList, rxModelInfoList
      } = this.state;
      this.drawCanvas({
        signals,
        isShowCtle,
        isShowRxCpad,
        isShowRx,
        isShowStimulus,
        ...getExpandModelConnectWidth(txModelInfoList, rxModelInfoList)
      });
    });
  }

  render() {
    const {
      modelVisible = {}, canvasVisible = {},
      clickSignalInfo, hspiceConfig, clickSignal,
      controllerSignal, deviceSignal, expandModelConnectVisible,
      txModelInfoList, rxModelInfoList
    } = this.state;
    const { signals, libraryStatus, channelType, designType } = this.props;
    const { controller, device } = hspiceConfig;
    const pcbBoxStyle = getPCBBoxStyle(getExpandModelConnectWidth(txModelInfoList, undefined, "number-tx"), signals, expandModelConnectVisible, canvasVisible.stimulus, channelType);
    return (
      <div className="aurora-setup-border" id="andes-v2-hspice-simulation">
        <span className="out-title-color font-bold">
          HSPICE Simulation
        </span>
        <div className={`${classNamePrefix}-container${canvasVisible.stimulus ? ` ${classNamePrefix}-container-stimulus` : ''}`}>
          {/* title */}
          <div className={`${classNamePrefix}-title-box ${canvasVisible.ctle ? classNamePrefix + '-title-box-exsit-ctle' : ''} ${expandModelConnectVisible ? classNamePrefix + '-title-box-expand-model-connect' : ''}`}>
            {this.titleRender()}
          </div>
          {/* canvas */}
          <div className={`${classNamePrefix}-canvas-box ${expandModelConnectVisible ? `${classNamePrefix}-canvas-box-expand-model` : ""}`} >
            {/* child title */}
            {expandModelConnectVisible ? <div
              className={`${classNamePrefix}-canvas-expand-model-connect-box`}
              style={{ left: 320 + (canvasVisible.stimulus ? 200 : 0), top: 10 }}>
              <ExpandModelConnect
                type="expand-model-title"
                designType={designType}
                clickPCBBox={(e) => this.clickPCBBox(e, !expandModelConnectVisible)}
                {...getExpandModelConnectWidth(txModelInfoList, rxModelInfoList, "object-modelTypes")}
              />
            </div> : null}
            {signals.map((signal, index) => {
              const signalName = signal.name;
              return (
                <div key={`hspice-${signalName}-${index}`}>
                  {this.positionEleRender(signalName, index)}
                </div>
              );
            })}
            {/* basic pcb box */}
            {signals.length > 0 ? <div
              className={`${classNamePrefix}-canvas-pcb-box`}
              style={pcbBoxStyle}
              onClick={(e) => channelType !== END_TO_END_CHANNEL && this.clickPCBBox(e, !expandModelConnectVisible)}
              title={channelType !== END_TO_END_CHANNEL ? `Click to ${expandModelConnectVisible ? "collapse" : "expand"} channel settings` : undefined}
            >
              {channelType === END_TO_END_CHANNEL ? null
                : expandModelConnectVisible ? <ShrinkOutlined className={`${classNamePrefix}-pcb-box-icon`} />
                  : <ArrowsAltOutlined className={`${classNamePrefix}-pcb-box-icon`} />}
            </div> : null}
            <canvas
              id="andes-v2-hspice-simulation-canvas"
              width="1250"
              height="400"
            ></canvas>
            {/* Die Model is not shown tip */}
            {designType === PACKAGE && expandModelConnectVisible
              ? <div className={`${classNamePrefix}-die-model-not-shown-tip`} style={{ top: pcbBoxStyle.height + 47, left: pcbBoxStyle.left + (pcbBoxStyle.width - 160) / 2 }}>
                Die model is not shown
                <Tooltip
                  classNames={{ root: 'aurora-tooltip andes-ami-model-tooltip andes-ami-model-tooltip-die-model' }}
                  title={`Die model is not shown since it is not included in transient simulation.\nIt will be included in calculation of return loss.`}
                >
                  <InfoCircleOutlined className="tip-icon" />
                </Tooltip>
              </div>
              : null}
            {modelVisible.txModel && (
              <TxModel
                closeModal={(model, applyAll) => this.closeModal("txModel", model, applyAll)}
                model={clickSignalInfo.txModel}
                libraryStatus={libraryStatus}
                signalName={clickSignalInfo.signalName}
                changeCanvasEle={this.changeCanvasEle}
                signal={channelType === END_TO_END_CHANNEL ? controllerSignal : clickSignal}
              />
            )}
            {modelVisible.rxModel && (
              <RxModel
                closeModal={(model, applyAll) => this.closeModal("rxModel", model, applyAll)}
                model={clickSignalInfo.rxModel}
                libraryStatus={libraryStatus}
              />
            )}
            {modelVisible.ctleModel && (
              <CtleModel
                closeModal={(model, applyAll) => this.closeModal("ctleModel", model, applyAll)}
                model={clickSignalInfo.ctleModel}
                signal={channelType === END_TO_END_CHANNEL ? deviceSignal : clickSignal}
                controller={controller}
                device={device}
                libraryStatus={libraryStatus}
              />
            )}
            {modelVisible.rxCpadModel && (
              <RxCpadModel
                closeModal={(model, applyAll) => this.closeModal("rxCpadModel", model, applyAll)}
                model={clickSignalInfo.rxCpadModel}
                libraryStatus={libraryStatus}
                signalName={clickSignalInfo.signalName}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SimulationContent;
